export interface MapVehicle {
  strUnitID?: string;
  strUnitId?: string;
  strFullName?: string;
  strVehicleNo?: string;
  fLat?: number | string | null;
  fLon?: number | string | null;
  tiDeviceStatus?: number | null;
  dtDateTime?: string;
  strDate?: string;
  strTime?: string;
  strTimeAge?: string;
  iSpeed?: number | string | null;
  siAngle?: number | null;
}

export const STATUSES = [
  { label: 'نامشخص', color: '#8794a9' }, { label: 'متصل به سرور', color: '#48b9f2' },
  { label: 'قطع ارتباط', color: '#f66d7c' }, { label: 'حرکت', color: '#35d89b' },
  { label: 'توقف', color: '#e8ae4b' }, { label: 'سوئیچ بسته', color: '#8998b5' },
  { label: 'سوئیچ باز', color: '#aa92ff' }, { label: 'اخطار', color: '#ff8b4d' },
];

